module.exports = __webpack_public_path__ + "media/src/website/images/locations/germering/02-9be136ad35202996252b8ff8c49f406f.jpg";